import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  fetchExtraFeed,
  switchLanguage,
  fetchNowNext,
  fetchFBT,
} from '../actions';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import {
  PLAYER_EXC,
  PLAYER_LIVE,
  PATH_LIVE,
  SHORTCUT_DIALOG,
} from '../constants';
import NowNext from './NowNext';
import NowNextAccurate from './NowNextAccurate';
import translate from './TranslateHOC';
import Player from './Player';
import PlayerPlayButton from './PlayerPlayButton';
import ProgSignUpModal from './ProgSignUpModal';
import ShortcutDialog from './player/modals/ShortcutDialog';
import PageMeta from './PageMeta';
import {
  cleanQueryString,
  hardExpired,
  imageFallback,
  cmsImageResize,
  formatDateAndTime,
  formatFromDate,
  isPrerenderAgent,
} from '../helpers';
import { Button as ButtonV2 } from '../v2/components/button/Button';
import { PlayerSlate } from '../v2/components/playerSlate/PlayerSlate';
import { bindActionCreators } from 'redux';
import { show } from 'redux-modal';
import { getItemName } from '../mys4c_helpers';

class Live extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentProg: 0,
      showSignUp: false,
      showShortcut: false,
      playerState: 'inactive',
      firstFetch: true,
      hardExpired: false,
      updateProg: false,
      updatedProgDetails: {},
      updateSched: false,
      updateSchedDetails: {},
    };
    this.handlePlayerStateChange = this.handlePlayerStateChange.bind(this);
    this.handleUpdateProgDetails = this.handleUpdateProgDetails.bind(this);
  }

  handlePlayerStateChange = (newState) => {
    this.setState({ playerState: newState });
  };

  handleUpdateProgDetails = (detail) => {
    if (typeof detail === 'object' && detail !== null) {
      const title = detail.nowProgramme.title;
      const seriesTitle = detail.nowProgramme.series_title;
      const programmeTitle = detail.nowProgramme.programme_title;

      const thisTitle =
        seriesTitle === null || seriesTitle === ''
          ? programmeTitle
          : programmeTitle === null || title === ''
          ? seriesTitle
          : seriesTitle + ' - ' + programmeTitle;

      const billing = detail.nowProgramme.billing
        ? detail.nowProgramme.billing
        : '';

      this.setState({
        updateProg: true,
        updatedProgDetails: {
          title: thisTitle,
          description: billing,
          progNow: detail.nowProgramme,
          progNext: detail.nextProgramme,
        },
      });
    } else {
      console.error('Invalid event object');
    }
  };

  componentDidMount = () => {
    /* Pass the feedURL and get info - returns empty if none */
    this.props.extraFeedData(this.props.match.params.feedUrl);
    window.scrollTo(0, 0);

    // Fetch FBT using Redux action
    this.props.fetchFBT();

    // Heartbeat here to check for changes to the feed
    this.heartbeatInterval = setInterval(() => {
      this.props.extraFeedData(this.props.match.params.feedUrl);

      this.setState({
        hardExpired: hardExpired(
          this.props.extraFeed.timeShifted,
          this.props.extraFeed.endDateTime,
          this.props.extraFeed.streamExpireDateTime
        ),
      });
    }, 60000);
  };

  componentDidUpdate = (prevProps) => {
    // check for differences in feed
    if (!_.isEqual(this.props.extraFeed, prevProps.extraFeed)) {
      if (!this.state.firstFetch) {
        // check for change in end time and update the player
        if (
          this.props.extraFeed.endDateTime !== prevProps.extraFeed.endDateTime
        ) {
          const newTimestamp = formatDateAndTime(
            this.props.extraFeed.endDateTime
          ).time;
          const event = new CustomEvent('updateAdhocEndTime', {
            detail: { newTimestamp },
          });
          window.dispatchEvent(event);
        }
      } else {
        this.setState({ firstFetch: false });
      }
    }

    // Handle FBT changes
    if (
      this.props.fbt !== prevProps.fbt &&
      this.props.fbt &&
      !this.props.fbtError
    ) {
      // Set FBT as session token if user is not authenticated
      if (!this.props.auth && this.props.fbt) {
        window.bws_session_token = this.props.fbt;
        // Generate and set itemName for FBT
        const itemName = getItemName('live', this.props.fbt);
        if (itemName) {
          window.itemName = itemName;
        }
      }
    }
  };

  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    /* Redirect to the other language url when changeing language */
    if (
      parseInt(this.state.currentProg, 10) !== 0 &&
      parseInt(this.props.curLang, 10) !== parseInt(nextProps.curLang, 10) &&
      parseInt(this.props.curLang, 10) ===
        parseInt(nextProps.extraFeed.url_lang, 10)
    ) {
      if (nextProps.match.params.feedUrl) {
        this.props.extraFeedData(nextProps.extraFeed.other_url);
        this.props.history.push(
          `${PATH_LIVE}/${nextProps.extraFeed.other_url}`
        );
      }
    }

    /* Update when changing feeds */
    if (this.props.match.params.feedUrl !== nextProps.match.params.feedUrl) {
      this.props.extraFeedData(nextProps.match.params.feedUrl);
      window.scrollTo(0, 0);
    }

    /* Keep the app language the same as the feed language */
    if (
      Object.keys(this.props.extraFeed).length <= 0 &&
      this.props.extraFeed !== nextProps.extraFeed
    ) {
      if (
        nextProps.extraFeed.url_lang &&
        parseInt(nextProps.extraFeed.url_lang, 10) !==
          parseInt(this.props.curLang, 10)
      ) {
        this.props.switchLanguage(
          parseInt(nextProps.extraFeed.url_lang, 10) === 0 ? 1 : 0
        );
      }
    }
  };

  thisProg = (val) => {
    this.setState({ currentProg: val });
  };

  componentWillUnmount() {
    clearInterval(this.heartbeatInterval);
    clearInterval(this.moreLikeTimer);
    // Clear the feed data when unmounting
    this.props.extraFeedData(null);
  }

  toggleLoginPrompt = (e) => {
    this.setState({ showSignUp: !this.state.showSignUp });
  };

  switchLang = () => {
    this.props.switchLanguage(this.props.curLang);
  };

  toggleShortcutPrompt = (e) => {
    this.props.show(SHORTCUT_DIALOG, {});
  };

  render() {
    const { extraFeed, curLang, strings, progNow, fbtError } = this.props;

    let auth = this.props.auth;
    if (this.props.fbt && !auth && !fbtError) {
      auth = true;
    }

    const extraFeedPath = extraFeed.other_url;
    const isLive =
      this.props.location.pathname === PATH_LIVE ||
      this.props.location.pathname === PATH_LIVE + '/'; // capture /Live/
    const extraFeedName =
      !isLive && extraFeed && extraFeed.streamName
        ? extraFeed.streamName
        : null;
    const extraFeedNameClean =
      !isLive && extraFeed && extraFeed.streamName
        ? cleanQueryString(extraFeed.streamName)
        : null;
    const formattedStartDateTime = formatDateAndTime(
      extraFeed.startLiveDateTime
    );
    const formattedEndDateTime = formatDateAndTime(extraFeed.endDateTime);
    const adhocStartDate = formattedStartDateTime.date;
    const adhocEndDate = formattedEndDateTime.date;
    const adhocStartTimeBST = formattedStartDateTime.BSTTime;
    const adhocEndTimeBST = formattedEndDateTime.BSTTime;

    const isPrerender = isPrerenderAgent();

    const disablePlayBack = !auth ? true : false;
    let progNowTitle;

    const liveDescription = this.state.updateProg
      ? this.state.updatedProgDetails.description
      : isLive && progNow
      ? progNow.billing
      : extraFeed?.description;

    if (progNow) {
      progNowTitle =
        progNow.series_title === null || progNow.series_title === ''
          ? progNow.programme_title
          : progNow.programme_title === null || progNow.programme_title === ''
          ? progNow.series_title
          : progNow.series_title + ' - ' + progNow.programme_title;
    }

    if (this.state.updateProg) {
      progNowTitle = this.state.updatedProgDetails.title;
    }

    const noStream =
      !isLive && Object.keys(extraFeed).length < 1 ? true : false;

    return (
      <div className={`live main live--${this.state.playerState}`}>
        <PageMeta
          title={strings.watchLive}
          description={strings.metaDescriptionLive}
        />
        <div className="playerPage">
          {/* if user's not auth'ed and has clicked to play, then will get this pseudo-modal */}
          <ShortcutDialog trans={strings} />

          {
            /* this is the live feed - use title and image from progNow */
            isLive && progNow && Object.keys(extraFeed).length < 1 && (
              <div>
                <h1 className="programme__title programme__title--live-stream">
                  <span className="programme__title-tag">{strings.live}</span>
                  {progNowTitle}
                </h1>
              </div>
            )
          }
          {
            /* this is an extra feed - use title and image from extraFeed obj */
            extraFeed && Object.keys(extraFeed).length > 0 && (
              <div>
                <h1 className="programme__title programme__title--live-stream">
                  {extraFeed.title}
                  {extraFeed &&
                    extraFeed.otherCommsUrl &&
                    extraFeed.otherCommsUrl.length > 0 && (
                      <div className="btn-holder">
                        <span
                          className="btn btn--small btn--white"
                          onClick={this.switchLang}
                        >
                          {extraFeed.otherCommsUrl}
                        </span>
                      </div>
                    )}
                </h1>
              </div>
            )
          }

          {(isPrerender ||
            (!this.state.hardExpired &&
              !disablePlayBack &&
              !(!isLive && extraFeedName === null))) && (
            <div className="programme__player">
              <Player
                curLang={curLang}
                type={!isLive ? PLAYER_EXC : PLAYER_LIVE}
                excStream={extraFeedName}
                excStreamClean={extraFeedNameClean}
                streamingUrl={extraFeed.streamingUrl}
                streamTitle={extraFeed.title}
                streamImg={
                  extraFeed.image
                    ? cmsImageResize(extraFeed.image, '1920x1080')
                    : ''
                }
                isTriggerAutoPlay={true}
                onChange={this.handlePlayerStateChange}
                adhocStartDate={adhocStartDate}
                adhocStartTime={adhocStartTimeBST}
                adhocEndDate={adhocEndDate}
                adhocEndTime={adhocEndTimeBST}
                timeShifted={extraFeed.timeShifted}
                handleUpdateProgDetails={this.handleUpdateProgDetails}
                extraFeedPath={extraFeedPath}
              />
            </div>
          )}

          {this.state.hardExpired && (
            <PlayerSlate
              text={
                extraFeed.timeShifted
                  ? strings.streamNoLongerAvailableForCatchUp
                  : strings.streamNotAvailableForCatchUp
              }
            />
          )}

          {disablePlayBack && !isPrerender && (
            <div
              className={
                this.state.showSignUp
                  ? 'programme__live-holder-signup'
                  : 'programme__live-holder'
              }
            >
              {/* playback disabled - show }

						{/* live programme - get relevant image for holder */}
              {this.state.showSignUp && (
                <ProgSignUpModal
                  toggleThis={this.toggleLoginPrompt}
                  loginRedirect={
                    !auth &&
                    this.props.location.pathname &&
                    this.props.location.pathname !== '/'
                      ? this.props.location.pathname
                      : ''
                  }
                />
              )}
              {progNow && Object.keys(extraFeed).length < 1 && (
                <div
                  className="programme__live-holder-image"
                  onClick={this.toggleLoginPrompt}
                >
                  <div className="programme__live-play-icon">
                    <PlayerPlayButton disableAnimation={true} />
                  </div>
                  <img
                    src={`https://www.s4c.cymru/amg/1920x1080/${progNow.thumbnail_url}`}
                    alt={progNow.title}
                    onError={(e) =>
                      imageFallback(
                        e,
                        'https://www.s4c.cymru/amg/1920x1080/clic-c.jpg'
                      )
                    }
                  />
                </div>
              )}

              {extraFeed && Object.keys(extraFeed).length > 0 && (
                <div
                  className="programme__live-holder-image"
                  onClick={this.toggleLoginPrompt}
                >
                  <div className="programme__live-play-icon">
                    <PlayerPlayButton disableAnimation={true} />
                  </div>
                  <img
                    src={cmsImageResize(extraFeed.image, '1920x1080')}
                    alt={extraFeed.title}
                    onError={(e) =>
                      imageFallback(
                        e,
                        'https://www.s4c.cymru/amg/1920x1080/clic-c.jpg'
                      )
                    }
                  />
                </div>
              )}
            </div>
          )}

          {!noStream && (
            <ProgrammeInfo>
              {liveDescription && (
                <Description>
                  {liveDescription}
                  {extraFeed.timeShifted && (
                    <div>{`${strings.expires} ${formatFromDate(
                      curLang,
                      extraFeed.streamExpireDateTime
                    )}`}</div>
                  )}
                </Description>
              )}

              <ShortCutButtonContainer>
                <ButtonV2
                  onClick={this.toggleShortcutPrompt}
                  icon
                  iconType="material"
                  label={strings.keyboardShortcuts}
                  materialLabel="keyboard"
                  type="tertiary"
                />
              </ShortCutButtonContainer>
            </ProgrammeInfo>
          )}

          <section className="now-next-container">
            <h2 className="section-title">
              {strings ? `${strings.nowAndNext} ` : 'Now and next '}
              <Link className="section-title__link" to="/TVSchedule">
                {strings ? strings.fullListings : 'Full listings'}
              </Link>
            </h2>
            {!this.state.updateProg && (
              <NowNext
                pathname={this.props.location.pathname}
                getVal={this.thisProg}
                nowNextClass="now-next--noskew"
              />
            )}
            {this.state.updateProg && (
              <NowNextAccurate
                progNow={this.state.updatedProgDetails.progNow}
                progNext={this.state.updatedProgDetails.progNext}
                pathname={this.props.location.pathname}
                getVal={this.thisProg}
                nowNextClass="now-next--noskew"
              />
            )}
          </section>
        </div>
      </div>
    );
  }
}

const ProgrammeInfo = styled.div`
  @media screen and (min-width: 960px) {
    display: grid;
    grid-gap: 20px;
    grid-template-columns: 2fr 1fr;
  }
`;

const ShortCutButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 27px;
  padding: 0 20px;
  @media screen and (min-width: 768px) {
    padding: 0;
  }
  a {
    padding: 0 15px 0 5px;
  }
  @media screen and (min-width: 960px) {
    align-items: end;
    justify-content: flex-start;
    flex-direction: column;
    a {
      padding: 0;
    }
  }
`;

const Description = styled.p`
  font-size: 18px;
  color: ${(props) => props.theme.color.black};
  letter-spacing: -0.02em;
  margin: 0 0 4px;
  padding: 18px 10px 18px;
  white-space: pre-line;
  @media screen and (min-width: 768px) {
    padding: 18px 0;
  }
`;

const mapStateToProps = (state) => {
  return {
    curLang: state.curLang,
    extraFeed: state.extraFeedItems.success,
    extraFeedsHasErrored: state.extraFeedItems.error,
    extraFeedsIsLoading: state.extraFeedItems.loading,
    progNow: state.now.success[0],
    auth: state.auth.authenticated,
    fbt: state.fbt.success,
    fbtError: state.fbt.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    extraFeedData: (slug) => dispatch(fetchExtraFeed(slug)),
    switchLanguage: (lang) => dispatch(switchLanguage(lang)),
    fetchNowNext: () => dispatch(fetchNowNext()),
    fetchFBT: () => dispatch(fetchFBT()),
    show: bindActionCreators(show, dispatch),
  };
};

export default translate(connect(mapStateToProps, mapDispatchToProps)(Live));
